// How GroupFind judges a group it found -- by name search or by id (a slug
// landing, a resumed session, or the parent handing the id back). One function
// so both paths agree (#730 final review C2): a group that participates at no
// level can never flip to "Verified" on the second pass.
//
//   'former_ichra'       a former Benefit Bay employer: declined, and told why
//   'non_participating'  participates at NO level and the parent will decide
//                        (the V2 wizard asks the client's state)
//   'error'              fails the asked levels: GroupFind's own message
//   'ok'                 verified
export function judgeFoundGroup (group, levels, { nonParticipatingAlert, canHandOff }) {
    if (group.former_ichra || (group.config && group.config.former_ichra)) return 'former_ichra'
    const asked = levels || []
    if (!nonParticipatingAlert || asked.some(level => group[level])) return 'ok'
    if (canHandOff && !group.paying && !group.financial_advisor && !group.dpc) return 'non_participating'
    return 'error'
}
